import React from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { ThemeContext } from "../context/themeContext";

export const Toggle = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);

  return (
    <div className="transition duration-500 ease-in-out rounded-full p-2">
      {theme === "dark" ? (
        <div className=" p-1 rounded-full shadow-sm shadow-slate-600">
          <FaSun
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="text-yellow-300 dark:text-yellow-200 text-2xl cursor-pointer"
          />
        </div>
      ) : (
        <div className="p-1 rounded-full shadow-sm shadow-slate-400">
          <FaMoon
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="text-gray-600 dark:text-gray-500 text-2xl cursor-pointer"
          />
        </div>
      )}
    </div>
  );
};
